module.exports = __webpack_public_path__ + "static/newsPub-e278a9ca40cfabd3f2361b81194b9434.jpeg";